module.exports = __webpack_public_path__ + "static/img/2-7.12024b2b.png";